import { render } from "./subPageFooter.vue?vue&type=template&id=20fbb824&scoped=true"
import script from "./subPageFooter.vue?vue&type=script&lang=js"
export * from "./subPageFooter.vue?vue&type=script&lang=js"

import "./subPageFooter.vue?vue&type=style&index=0&id=20fbb824&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20fbb824"]])

export default __exports__